module.exports = __webpack_public_path__ + "static/media/n00123.1210c283.jpg";